import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
 

export const vpDetailSlice = createSlice({
  name: "vpDetail",
  initialState: { 
    erpContractList: [], 
    isFetching: true,
    isSuccess: false, 
  },
  reducers: {
    clearState: (state) => {
      state.erpContractList = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
    onErpContractSelect: (state, { payload }) => {
      var body = payload.responseBody;
      if (body && body.length > 0) {
        state.erpContractList = JSON.parse(body);
      }

      return state;
    }, 
  }, 
});
export const { clearState, onErpContractSelect } = vpDetailSlice.actions;

export const vpDetailSelector = (state) => state.vpDetail;

export const vpDetailReducer = vpDetailSlice.reducer;
